import React from 'react'

export interface TreeNode<T> {
  label: string
  value: T
  children?: TreeNode<T>[]
  selectable?: boolean
  icon?: React.ReactNode
  className?: string
  linkView?: boolean
}

export const flattenTreeNodes = <T,>(
  nodes: TreeNode<T>[],
  level = 0
): (TreeNode<T> & {level: number})[] => {
  const children = nodes.flatMap(x =>
    flattenTreeNodes(x.children ?? [], level + 1)
  )
  return nodes.map(x => ({...x, level})).concat(children)
}
